import { __read } from "tslib";
import { AppType } from '@office-start/app-gallery-types';
import { useCapabilities } from '@office-start/capabilities-service';
import { getPlatformType } from '@office-start/data-resolver-app-pinning';
import { useThirdPartyWorkloads } from '@office-start/workloads-service';
import * as React from 'react';
import { sanitizeImageUrl } from './utils';
/**
 * Custom React Hook responsible for resolving third party tile data
 */
export function useThirdPartyTileData() {
    var capabilities = useCapabilities().data;
    var thirdPartyWorkloads = useThirdPartyWorkloads().data;
    var _a = __read(React.useState([]), 2), tileData = _a[0], setTileData = _a[1];
    React.useEffect(function () {
        if ((capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled) && thirdPartyWorkloads) {
            var edges = thirdPartyWorkloads
                .filter(function (appDefinition) {
                // Graph apps are taken care of by the useWorkspacesTileData() hook.
                return appDefinition.CollectorId !== AppType.AAD;
            })
                .map(function (appDefinition) {
                // Add the workload as a new edge.
                return {
                    node: {
                        id: appDefinition.Id,
                        name: appDefinition.Text,
                        accessibleName: appDefinition.Title || appDefinition.Text,
                        platformType: getPlatformType(appDefinition.CollectorId),
                        icon: {
                            __typename: 'RemoteImage',
                            src: sanitizeImageUrl(appDefinition.ThirdPartyIcon),
                            isFullBleed: true,
                        },
                        brandingColor: appDefinition.Color,
                        isPinnable: true,
                        enablePlatformCommands: false,
                        lockedIndex: undefined,
                        pinnedIndex: undefined,
                        canLaunchOut: true,
                        isInUse: false,
                        anchoredIndex: undefined,
                    },
                };
            });
            setTileData(edges);
        }
    }, [capabilities, thirdPartyWorkloads]);
    return tileData;
}
//# sourceMappingURL=useThirdPartyTileData.js.map